const isSsoPassword = (password?: string) => Boolean(password?.startsWith('SSO-'));

export const normalizeCreateUserPayload = (
  data: Record<string, any>,
  createSsoPassword: () => string,
) => {
  const transformedData = {...data};
  const isSsoEnabled = Boolean(transformedData.__isSso);

  delete transformedData.__isSso;

  if (isSsoEnabled) {
    if (!isSsoPassword(transformedData.password)) {
      transformedData.password = createSsoPassword();
    }
  }

  return transformedData;
};
